'use es6';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isEnabledForViz } from 'reporting-ui-components/reports/inferLogic/isReportingVizEnabled';
import { isSalesAnalyticsWidget } from 'reporting-ui-components/components/customWidgets/lib/salesExplorer';
import { setLimit } from 'dashboard-lib/public/report/report-logic';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import ReportErrorMessage from '../ReportErrorMessage';
import { selectAllGates } from 'dashboard-lib/public/userInfo';
import widgets from 'reporting-ui-components/components/customWidgets/constants/widgets';
import { ReportOptions } from 'reporting-snowflake/relational/resolve/resolve-records';
import { AREA, PIE, LINE, BAR, COLUMN, DONUT } from 'reporting-data/constants/chartTypes';
import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HIGHCHARTS_CHART_TYPES = [AREA, PIE, LINE, BAR, COLUMN, DONUT,
// Snowflake Highcharts Types
VisualTypes.COMBO, VisualTypes.HORIZONTAL_BAR, VisualTypes.VERTICAL_BAR];
const EmailReportBody = ({
  rowLimit = 8,
  setIsRendered,
  overriddenReport
}) => {
  const isDealsForecastReport = overriddenReport.getIn(['displayParams', 'customWidget', 'type']) === widgets.DEAL_FORECAST;
  const gates = useSelector(selectAllGates);
  const renderReportResolver = (report, initialReportOptions) => /*#__PURE__*/_jsx(PlatformReportResolver, {
    report: report,
    allowDrilldown: false,
    setIsRendered: setIsRendered,
    onError: setIsRendered,
    errorRenderer: ReportErrorMessage,
    initialReportOptions: initialReportOptions,
    disableSVGs: true,
    disableIframes: true
  });
  const isSnowflakeReport = !!overriddenReport.get('reportDefinition');
  const chartType = isSnowflakeReport ? overriddenReport.getIn(['reportDefinition', 'visual', 'type']) : overriddenReport.get('chartType');
  if (HIGHCHARTS_CHART_TYPES.includes(chartType)) {
    const reportBody = overriddenReport.setIn(['displayParams', 'hideLegend'], true);
    const reportLegend = overriddenReport.setIn(['displayParams', 'onlyLegend'], true);
    return isEnabledForViz(overriddenReport, gates) || isSalesAnalyticsWidget(overriddenReport) || isSnowflakeReport ?
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("div", {
      className: "email-report-container",
      children: renderReportResolver(reportLegend)
    }, "reporting-visualization") :
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs("div", {
      className: "email-report-container",
      children: [renderReportResolver(reportBody), /*#__PURE__*/_jsx(PlatformReportResolver, {
        report: reportLegend
      })]
    });
  }
  const withTableLimit = (chartType === 'TABLE' || isDealsForecastReport) && !isSnowflakeReport ? setLimit(rowLimit, overriddenReport) : overriddenReport;
  const initialSnowflakeReportOptions = chartType === 'TABLE' && isSnowflakeReport ? ReportOptions({
    limit: rowLimit,
    offset: 0
  }) : undefined;
  const withTableSettings = chartType === 'TABLE' ? withTableLimit.setIn(['displayParams', 'hidePagination'], true) : withTableLimit;
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsxs("div", {
      className: "email-report-container",
      children: [
      //include both svg chart & table for deal forecast widget
      isDealsForecastReport && /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "500",
        as: "div",
        children: /*#__PURE__*/_jsx(PlatformReportResolver, {
          report: overriddenReport,
          allowDrilldown: false,
          errorRenderer: () => null
        })
      }), renderReportResolver(withTableSettings, initialSnowflakeReportOptions)]
    })
  );
};
EmailReportBody.propTypes = {
  setIsRendered: PropTypes.func,
  rowLimit: PropTypes.number,
  overriddenReport: PropTypes.object.isRequired
};
export default EmailReportBody;